<template>
  <div class="job">
    <form class="col-12" @submit.prevent="handleSubmit" v-if="job">
      <div class="row">
        <div class="col-6">
          <h2>Job Detail</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>Job</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="description">Description:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="description"
            ref="job_description"
            name="description"
            placeholder="description"
            v-model="description"
          />
        </div>
        <div
          v-if="submitted && errors.has('description')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("description") }}
        </div>
      </div>
      <div>
        <template v-for="schedule_round in rounds">
          <div class="row" :key="schedule_round.id">
            <div class="col-2">
              <label>Round:</label>
            </div>
            <div class="col-9">
              <input
                type="text"
                class="form-control"
                enabled="false"
                :value="getRoundName(schedule_round)"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="notes">Notes:</label>
        </div>
        <div class="col-9">
          <textarea
            rows="4"
            class="form-control"
            id="notes"
            ref="site_notes"
            name="notes"
            placeholder="notes"
            v-model="notes"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <h3>Plants</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label>Available Plants</label>
        </div>
        <div class="col-6">
          <label>Selected Plants</label>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <draggable
            class="h-min-200 h-100 p-0"
            tag="ul"
            v-model="plant_list"
            v-bind="dragOptions"
            :move="onMove"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group
              type="transition"
              :name="'plant-list'"
              class="d-block h-100"
            >
              <li
                class="plant-select-item"
                v-for="element in plant_list"
                :key="id + 'pera' + element.id"
              >
                <i
                  :class="
                    element.fixed
                      ? 'fa fa-anchor'
                      : 'glyphicon glyphicon-pushpin'
                  "
                  @click="element.fixed = !element.fixed"
                  aria-hidden="true"
                ></i>
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
        </div>
        <div class="col-6">
          <draggable
            class="h-min-200 h-100 p-0"
            tag="ul"
            v-model="selected_plants"
            v-bind="dragOptions"
            :move="onMove"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group name="no" class="d-block h-100">
              <li
                class="plant-select-item"
                v-for="element in selected_plants"
                :key="id + 'plant' + element.id"
              >
                <i
                  :class="
                    element.fixed
                      ? 'fa fa-anchor'
                      : 'glyphicon glyphicon-pushpin'
                  "
                  @click="element.fixed = !element.fixed"
                  aria-hidden="true"
                ></i>
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">
          New
        </button>
        <button v-if="job" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      <div class="col-2" v-if="job">
        <button
          id="delete"
          v-if="job.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "JobDetail",
  props: {
    job: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    submitted: false,
    selected_plants: [],
    plant_list: [],
    description: "",
    notes: "",
    delayedDragging: false,
    rounds: [],
  }),
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    plants() {
      this._reload();
    },
    job() {
      this._reload();
      if (this.job == null) {
        this.rounds = [];
      } else {
        this.rounds = this.getRoundsForJob(this.job.id);
      }
    },
    schedule_rounds() {
      if (this.job == null) {
        this.rounds = [];
      } else {
        this.rounds = this.getRoundsForJob(this.job.id);
      }
    },
    available_jobs() {
      if (this.job == null) {
        this.rounds = [];
      } else {
        this.rounds = this.getRoundsForJob(this.job.id);
      }
    },
  },
  computed: {
    ...mapGetters("schedule", ["getRoundsForJob"]),
    ...mapState("schedule", ["schedule_rounds", "available_jobs"]),
    ...mapState("plants", ["plants"]),
    ...mapState("sites", ["sites"]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  mounted: function() {
    this.id = this._uid;
    this.$nextTick(function() {
      this._reload();
    });
    if (this.job == null) {
      this.rounds = [];
      this.notes = "";
    } else {
      this.rounds = this.getRoundsForJob(this.job.id);
      this.notes = this.job.notes;
    }
  },
  methods: {
    ...mapActions("jobs", ["apiSaveJob", "apiCreateJob"]),
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save();
        }
      });
    },
    getDescription() {
      if (!this.job) {
        return "";
      }
      return this.job.description;
    },
    getRoundName(schedule_round) {
      var result = schedule_round.round.name;
      result +=
        " - week " +
        (schedule_round.week_index + 1) +
        " - day " +
        (schedule_round.day_index + 1);
      schedule_round.personnels.forEach(personnel => {
        result += " - " + personnel.name;
      });
      return result;
    },
    _delete() {
      if (this.job && this.job.id > 0) {
        this.job.active = !this.job.active;
        this.apiSaveJob(this.job);
      }
    },
    _reload() {
      if (this.job) {
        this.description = this.job.description;
        this.notes = this.job.notes;
        var vm = this;
        this.selected_plants = this.job.plants.slice();
        var sites = this.sites.filter(function(value) {
          return value.customer_id == vm.job.customer_id;
        });
        this.plant_list = this.plants.filter(function(value) {
          var site_index = sites.findIndex(v => v.id == value.site_id);
          var index = vm.selected_plants.findIndex(v => v.id == value.id);
          return site_index > -1 && index < 0;
        });
      } else {
        this.selected_plants = [];
        this.plant_list = [];
        this.description = "";
        this.notes = "";
      }
    },
    save() {
      if (this.job) {
        if (this.selected_plants.length < 1) {
          alert("please select a plant");
          return;
        } else if (!this.$refs.job_description.value) {
          alert("please enter a name");
          return;
        }
        this.job.description = this.$refs.job_description.value;
        this.job.plants = this.selected_plants;
        this.job.notes = this.notes;

        if (this.job.id > 0) {
          this.apiSaveJob(this.job);
        } else {
          this.apiCreateJob(this.job);
        }
        this.$emit("saved");
      }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
  },
  components: {
    draggable,
  },
};
</script>
